import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const MainPage = () => import(/* webpackChunkName: "group-main" */ '@/components/main-page/MainPage.vue')
const Products = () => import(/* webpackChunkName: "group-products" */ '@/components/products/Products.vue')
const ProductView = () => import(/* webpackChunkName: "group-products" */ '@/components/product-view/ProductView.vue')
const Login = () => import(/* webpackChunkName: "group-auth" */ '@/components/auth/Login.vue')

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: { name: 'main-page' }
    },
    {
      path: '/home',
      name: 'main-page',
      component: MainPage
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/products/:id',
      name: 'product-view',
      component: ProductView,
      meta: { noindex: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { noindex: true }
    },
    {
      path: '*',
      redirect: { name: 'main-page' }
    }
  ]
})
